import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { ListLesson } from '../types'

export type lessonsType = 'pending' | 'accepted' | 'finished' | 'payment_pending'
export interface LessonsReducer {
  lessonsType: lessonsType
  pending: { lessons: ListLesson[]; lastFetchedAt: string | null }
  accepted: { lessons: ListLesson[]; lastFetchedAt: string | null }
  finished: { lessons: ListLesson[]; lastFetchedAt: string | null }
  payment_pending: { lessons: ListLesson[]; lastFetchedAt: string | null }
}

const initialState: LessonsReducer = {
  lessonsType: 'accepted',
  pending: {
    lastFetchedAt: null,
    lessons: []
  },
  accepted: {
    lastFetchedAt: null,
    lessons: []
  },
  finished: {
    lastFetchedAt: null,
    lessons: []
  },
  payment_pending: {
    lastFetchedAt: null,
    lessons: []
  }
}

interface SetLessonsTypePayload {
  lessonsType: lessonsType
}
export const SET_LESSONS_TYPE = createAction<SetLessonsTypePayload>('lessons_reducer/set_lessons_type')

interface FetchLessonsPayload {
  type: lessonsType
}
export type FetchLessonsActionType = PayloadAction<FetchLessonsPayload>
export const FETCH_LESSONS = createAction<FetchLessonsPayload>('lessons_reducer/fetch_lessons')
interface FetchLessonsSuccessPayload {
  lessons: ListLesson[]
  type: lessonsType
}
export const FETCH_LESSONS_SUCCESS = createAction<FetchLessonsSuccessPayload>('lessons_reducer/fetch_lessons_success')
export const FETCH_LESSONS_FAIL = createAction('lessons_reducer/fetch_lessons_failure')

interface AcceptLessonPayload {
  lessonId: number
}
export type AcceptLessonActionType = PayloadAction<AcceptLessonPayload>
export const ACCEPT_LESSON = createAction<AcceptLessonPayload>('lessons_reducer/accept_lesson')
export const ACCEPT_LESSON_SUCCESS = createAction<ListLesson>('lessons_reducer/accept_lesson_success')
export const ACCEPT_LESSON_FAIL = createAction('lessons_reducer/accept_lesson_fail')

export const lessonsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_LESSONS_TYPE, (state, action) => {
      return { ...state, lessonsType: action.payload.lessonsType }
    })
    .addCase(FETCH_LESSONS_SUCCESS, (state, action) => {
      return {
        ...state,
        [action.payload.type]: { lessons: action.payload.lessons, lastFetchedAt: new Date().toISOString() }
      }
    })
    .addCase(ACCEPT_LESSON_SUCCESS, (state, action) => {
      const updatedPendingPaymentLessons = [action.payload, ...state.payment_pending.lessons]
      const updatedPendingLessons = state.pending.lessons.filter((lesson) => lesson.id !== action.payload.id)
      return {
        ...state,
        payment_pending: { lessons: updatedPendingPaymentLessons, lastFetchedAt: state.payment_pending.lastFetchedAt },
        pending: { lessons: updatedPendingLessons, lastFetchedAt: state.pending.lastFetchedAt }
      }
    })
})
